import { useMediaQuery, useTheme } from "@mui/material";
import { boardTokens } from "@/shared/theme";

/** Width reserved beside a board for its evaluation bar: a thin strip on phones, the labelled bar elsewhere. */
export const useEvaluationGutterWidth = (): number => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"))
    ? boardTokens.evaluation.mobileGutterWidth
    : boardTokens.evaluation.gutterWidth;
};
